export const ACTIVATION_KEYS = ["Enter", " ", "Spacebar"]
export const INPUT_MODALITY_ATTR = "data-input-modality"
export const INPUT_MODALITY_POINTER = "pointer"
export const INPUT_MODALITY_KEYBOARD = "keyboard"

const KEYBOARD_MODALITY_KEYS = new Set([
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
])

const BOUND = Symbol.for("aqui-input-focus-modality")

export function setInputFocusModality(value, root = document) {
  root.documentElement.setAttribute(INPUT_MODALITY_ATTR, value)
}

export function setupInputFocusModality(root = document) {
  setInputFocusModality(INPUT_MODALITY_POINTER, root)
  if (root[BOUND]) return
  root[BOUND] = true

  root.addEventListener(
    "keydown",
    (event) => {
      if (KEYBOARD_MODALITY_KEYS.has(event.key)) setInputFocusModality(INPUT_MODALITY_KEYBOARD, root)
    },
    true
  )

  root.addEventListener(
    "pointerdown",
    () => setInputFocusModality(INPUT_MODALITY_POINTER, root),
    true
  )
}

export function isActivationKey(event) {
  return ACTIVATION_KEYS.includes(event.key)
}

export function shouldActivateClickEvent(event) {
  if (event.type !== "keydown") return true

  return isActivationKey(event)
}

export function activateClickOnSpace(event) {
  if (event.key !== " " && event.key !== "Spacebar") return

  event.preventDefault()
  event.currentTarget?.click()
}
